var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8C5 5.172 5 3.757 5.879 2.879C6.757 2 8.172 2 11 2H13C15.828 2 17.243 2 18.121 2.879C19 3.757 19 5.172 19 8V16C19 18.828 19 20.243 18.121 21.121C17.243 22 15.828 22 13 22H11C8.172 22 6.757 22 5.879 21.121C5 20.243 5 18.828 5 16V8Z",
    stroke: "current",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5 4.07617C4.025 4.17217 3.369 4.38917 2.879 4.87917C2 5.75717 2 7.17217 2 10.0002V14.0002C2 16.8282 2 18.2432 2.879 19.1212C3.369 19.6112 4.025 19.8282 5 19.9242M19 4.07617C19.975 4.17217 20.631 4.38917 21.121 4.87917C22 5.75717 22 7.17217 22 10.0002V14.0002C22 16.8282 22 18.2432 21.121 19.1212C20.631 19.6112 19.975 19.8282 19 19.9242",
    stroke: "current",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M9 13H15",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9H15",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9 17H12",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/Documents.0d9bd2bf4791e08f73b495ba44d05ef7.svg";
export { ForwardRef as ReactComponent };